export const LAYOUT_OBJECT_TYPES = [
  { value: 'asset', label: 'Location' },
  { value: 'contract', label: 'Account' },
  { value: 'service', label: 'Service' },
  { value: 'party', label: 'People' },
  { value: 'entity', label: 'Entity' },
]

export const getLayoutObjectTypeLabel = (objectType) =>
  LAYOUT_OBJECT_TYPES.find(({ value }) => value === objectType)?.label || objectType
